/**
 * Back, start-over and "Restart the check" are for walking the flow while
 * building it; real visitors never see them. On main they show only on the
 * local dev server. The `dev` branch sets this to `true` so a deployed preview
 * keeps them too — that one line is the whole difference between the branches.
 */
export const DEV_CONTROLS: boolean = process.env.NODE_ENV === "development";
